import type { FaireProductEntity } from "../../entity_types/product";

export const p_pbnr6hf7b6: FaireProductEntity = {
  token: "p_pbnr6hf7b6",
  type: "product",
  name: "Mini Candle Discovery Set",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/5724c12609cf69bd54432f45da2440f7358ee15d47be58b109e66d5492ce4331.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9cda72d2bc576ef64954e9a1689fc20ad9d02ce8642b6f27c1e012875c3f519.jpeg",
    "https://cdn.faire.com/fastly/f33c8501ef90968acde6a70104f21b8add3ef337ea66166faf80209e4498c287.jpeg",
  ],
  priceDollars: 41.25,
  description:
    "Discover your new favorite fragrance this holiday season with The Candle Discovery Set—three 2.25 oz votives in our signature fine-fragrance scents. Clean-burning, richly scented, and hand-poured into custom clay vessels, this set makes an elegant gift (or self-indulgence) for the season.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐢𝐧𝐠:\n• Soy wax blend to extend burn time\n• Organic cotton wick\n\n𝐒𝐢𝐠𝐧𝐚𝐭𝐮𝐫𝐞 𝐒𝐜𝐞𝐧𝐭𝐬:\n• Steeped Rose - An unadulterated floral that stays true to its namesake bloom-stems, thorns, and all.\n\n• Cece - Cedarwood smoke, sweet cardamom, and white leather. Grounded, mysterious, and addictive.\n\n• Neroli Leaf - Crisp, sparkling orange blossoms and crushed basil evoke a grove of flowering citrus trees.",
  tags: [],
  msrpDollars: 75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:16.170Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
